import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import RootComponent from './RootComponent';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <RootComponent />
);
